<template>
  <div>
    <div class="page-loader" v-show="pageLoading">
      <div>
        <PageLoader />
      </div>
    </div>

    <div v-show="!pageLoading">
      <div v-show="showGoBack" class="payroll">
        <img
          
          @click="goBack"
          class="back-arrow"
          src="../../../assets/images/arrow.png"
        />
      </div>
      <div class="payroll__nav">
        <div class="payroll__nav--item">
          <div
            class="payroll__nav--item-bar"
            v-bind:style="[
              breakDownNavButton
                ? { backgroundColor: '#5099de' }
                : { backgroundColor: '#c7c7c7' },
            ]"
          ></div>
          <p
            class="payroll__nav--item-pg"
            v-bind:style="[
              breakDownNavButton ? { color: '#5099de' } : { color: '#c7c7c7' },
            ]"
          >
            1. Earnings Breakdown
          </p>
        </div>
        <div class="payroll__nav--item">
          <div
            class="payroll__nav--item-bar"
            v-bind:style="[
              previewNavButton
                ? { backgroundColor: '#5099de' }
                : { backgroundColor: '#c7c7c7' },
            ]"
          ></div>
          <p
            class="payroll__nav--item-pg"
            v-bind:style="[
              previewNavButton ? { color: '#5099de' } : { color: '#c7c7c7' },
            ]"
          >
            2. Review & Submit
          </p>
        </div>
        <div class="payroll__nav--item">
          <div
            class="payroll__nav--item-bar"
            v-bind:style="[
              confirmNavButton
                ? { backgroundColor: '#5099de' }
                : { backgroundColor: '#c7c7c7' },
            ]"
          ></div>
          <p
            class="payroll__nav--item-pg"
            v-bind:style="[
              confirmNavButton ? { color: '#5099de' } : { color: '#c7c7c7' },
            ]"
          >
            3. Pay
          </p>
        </div>
        <div class="payroll__nav--item">
          <div
            class="payroll__nav--item-bar"
            v-bind:style="[
              successNavButton
                ? { backgroundColor: '#5099de' }
                : { backgroundColor: '#c7c7c7' },
            ]"
          ></div>
          <p
            class="payroll__nav--item-pg"
            v-bind:style="[
              successNavButton ? { color: '#5099de' } : { color: '#c7c7c7' },
            ]"
          >
            4. Success 🎉
          </p>
        </div>
      </div>
      <div v-if="breakDown">
        <BreakdownRegular
          :omittedIds="omittedIds"
          @clickedPreview="openPreview"
          @emitShowGoBack="showGoBack = true"
        />
      </div>
      <div v-if="preview">
        <PayrollPreview  @clickedConfirm="openConfirm" />
      </div>
      <div v-if="confirm">
        <PayrollConfirm @emitShowGoBack="showGoBack = false" @clickedSuccess="openSuccess" />
      </div>
      <div v-if="success">
        <PayrollSuccess />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/header";
import PageLoader from "../../partials/page-loader";
import Sidebar from "../../partials/sidebar";
import BreakdownRegular from "./breakdownRegular";
import PayrollPreview from "./preview";
import PayrollConfirm from "./confirm";
import PayrollSuccess from "./success";

export default {
  name: "processPayroll",
  components: {
    Header,
    Sidebar,
    PageLoader,
    BreakdownRegular,
    PayrollPreview,
    PayrollConfirm,
    PayrollSuccess,
  },
  data() {
    return {
      pageLoading: true,
      item: "regular",
      payroll: "payroll",
      showGoBack: false,
      breakDown: true,
      preview: false,
      confirm: false,
      success: false,
      breakDownNavButton: true,
      previewNavButton: false,
      confirmNavButton: false,
      successNavButton: false,
      omittedIds: [],
    };
  },
  methods: {
    goBack() {
      if (this.breakDown) {
        let title = this.$store.state.payrollTitle;
        let month = this.$store.state.payrollMonth;
        let year = this.$store.state.payrollYear;

        this.$router.push({
          name: "regularPayrollInitiate",
          query: { title, month, year },
        });
      } else if (this.preview) {
        this.omittedIds = this.$store.state.omittedEmployeeIds;
        this.openBreakdown();
      }
    },
    openBreakdown() {
      this.breakDown = true;
      this.preview = false;
      this.confirm = false;
      this.success = false;
      this.breakDownNavButton = true;
      this.previewNavButton = false;
      this.confirmNavButton = false;
      this.successNavButton = false;
    },
    openPreview(val) {
      window.scroll(0, 0);
      this.breakDown = false;
      this.preview = true;
      this.confirm = false;
      this.success = false;
      this.breakDownNavButton = true;
      this.previewNavButton = true;
      this.confirmNavButton = false;
      this.successNavButton = false;
    },
    openConfirm() {
      window.scroll(0, 0);
      this.breakDown = false;
      this.preview = false;
      this.confirm = true;
      this.success = false;
      this.breakDownNavButton = true;
      this.previewNavButton = true;
      this.confirmNavButton = true;
      this.successNavButton = false;
    },
    openSuccess() {
      window.scroll(0, 0);
      this.breakDown = false;
      this.preview = false;
      this.confirm = false;
      this.success = true;
      this.breakDownNavButton = true;
      this.previewNavButton = true;
      this.confirmNavButton = true;
      this.successNavButton = true;
    },
  },
  mounted() {
    let payrollId = this.$router.currentRoute.query.payroll_id;

    if (payrollId !== undefined) {
      this.pageLoading = false;

      this.previewNavButton = true;
      this.breakDown = false;
      this.confirm = true;
    } else {
      this.pageLoading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.payroll {
  padding-top: 30px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;

  .back-arrow {
    width: 25px;
    cursor: pointer;
    &:hover {
      opacity: 0.5;
    }
  }

  > .payroll__date {
    padding-bottom: 20px;
    text-align: right;
    font-size: 1rem;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.17;
    letter-spacing: normal;
    color: #000000;

    > span {
      color: #5099de;
    }
  }

  > p {
    text-align: left;
    font-size: 2rem;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.18;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    margin: 0;
  }

  > .payroll__div {
    border-top: 1px solid #caced5;
  }
}

.page-loader {
  padding-top: 50px;

  > div {
    width: 55px;
    margin: auto;
  }
}

.payroll__nav {
  margin-top: 40px;
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;

  > .payroll__nav--item {
    float: left;
    padding: 0 10px;
    flex: 2 033.3333333333%;

    > .payroll__nav--item-bar {
      height: 12px;
      border-radius: 20px;
      background-color: #c7c7c7;
    }

    > .payroll__nav--item-pg {
      font-size: 1rem;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.22;
      letter-spacing: normal;
      text-align: left;
      color: #c7c7c7;
      margin: 10px 0;

      @media (max-width: 768px) {
        font-size: 0.9rem;
      }
    }
  }
}
</style>